module.exports = __webpack_public_path__ + "img/Hypoxia-OVCA_GSE227019.68fd8a21.png";